{
  "nl": {
    "subscriptions": {
      "plans": {
        "free": {
          "title": "Gratis account"
        },
        "courses": {
          "title": "Nascholing Flatrate",
          "subtitle": "Volledige toegang tot alle fobizz nascholingsaanbiedingen.",
          "features": "<li><i class='bi bi-check-lg'></i><div>Toegang tot de volledige nascholingscatalogus</div></li><li><i class='bi bi-check-lg'></i><div>Toegang tot alle webinar-opnames</div></li><li><i class='bi bi-check-lg'></i><div>Praktijkgerichte oefeningen en materialen inbegrepen</div></li><li><i class='bi bi-check-lg'></i><div>Alle nascholingen met certificaat</div></li>"
        },
        "tools": {
          "title": "Tools Flatrate",
          "subtitle": "Onbeperkte toegang tot fobizz tools en AI-assistentie voor de les.",
          "features": "<li><i class='bi bi-check-lg'></i><div>Onbeperkt gebruik van alle digitale tools</div></li><li><i class='bi bi-check-lg'></i><div>Onbeperkte toegang tot AI-klaslokalen</div></li><li><i class='bi bi-check-lg'></i><div>Onbeperkt eigen AI-assistenten en chatbots maken</div></li><li><i class='bi bi-check-lg'></i><div>Geen registratie van leerlingen nodig</div></li>"
        },
        "combined": {
          "title": "Combi Flatrate",
          "subtitle": "Volledige toegang tot alle nascholingsaanbiedingen, tools en AI-assistentie.",
          "badge": "Populair",
          "features": "<li><i class='bi bi-check-lg'></i><div>Alle voordelen van de nascholings- en toolslicentie</div></li><li><i class='bi bi-check-lg'></i><div>Bespaar 25% ten opzichte van de afzonderlijke prijs</div></li><li><i class='bi bi-check-lg'></i><div>Toegang tot de volledige nascholingscatalogus</div></li><li><i class='bi bi-check-lg'></i><div>Onbeperkt gebruik van alle digitale tools incl. AI</div></li>"
        },
        "pricing_card": {
          "year": "Jaar",
          "month": "Maand",
          "buy_now": "Nu kopen",
          "checkout_error": "Er is een fout opgetreden bij het openen van de checkout. Probeer het later opnieuw."
        }
      }
    }
  }
}
